<template>
	<div id="wrapper" v-if="$route.meta.isAI">
		<router-view />
		<Snackbar :text="'회원가입이 완료 되었어요.'" v-if="isNewJoin" />
	</div>
	<div id="wrapper" v-else>
		<topMenu v-if="$route.meta.authRequired" />
		<router-view />
		<footerView v-if="$route.meta.authRequired" />
		<div id="loading">
			<div class="car"></div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import TopMenu from '@/components/TopMenu'
import FooterView from '@/components/FooterView'
import { EventBus } from "@/modules/event-bus"
import Snackbar from '@/components/ai/AiSnackbar'
// import VueCookies from 'vue-cookies'

export default {
	name: 'App',
	components: { TopMenu, FooterView, Snackbar },
	data: function () {
		return {
			isReaction: false,
			loginCheckTimer: null,
			aiIsReaction: false,
			aiLoginCheckTimer: null,
			isNewJoin: false
		}
	},
	created() {
		// 사용자 action
		EventBus.$on("event-reaction", () => {
			this.isReaction = true;

			if (this.loginCheckTimer == null) {
				this.loginCheckTimer = setInterval(this.refreshLogin, 1800000)
			}
		});

		//ai jwt검증 호출
		EventBus.$on("ai-event-reaction", () => {
			this.aiIsReaction = true;

			if (this.aiLoginCheckTimer == null) {
				this.aiLoginCheckTimer = setInterval(this.aiRefreshLogin, 1800000)
			}
		});

		// 로그아웃
		EventBus.$on("event-logout", () => {
			this.isReaction = false;
			clearInterval(this.loginCheckTimer);
			this.loginCheckTimer = null;
		});

		// ai로그아웃
		EventBus.$on("ai-event-logout", () => {

		this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));

			this.aiIsReaction = false;
			clearInterval(this.aiLoginCheckTimer);
			this.aiLoginCheckTimer = null;
		});

		EventBus.$on("is-new-login", () => {
			this.isNewJoin = true;
			setTimeout(() => {
				this.isNewJoin = false
			}, 3000)
		})
	},
	methods: {
		refreshLogin() {
			if (this.isReaction) {
				window.$store.dispatch('Login/refreshLogin')
					.then((result) => {
						this.isReaction = false;
						if (!result) {
							this.logout();
						}
					});
			} else {
				this.logout();

			}
		},


		logout() {
			window.$store
				.dispatch('Login/logout')
				.then(() => {
					this.$router.push('/');
				})
		},

		aiRefreshLogin() {
			if (this.aiIsReaction) {
				window.$store.dispatch('Login/aiRefreshLogin')
					.then((result) => {
						this.aiIsReaction = false;
						if (!result) {
							this.aiLogout();
						}
					});
			} else {
				this.aiLogout();
			}
		},

		aiLogout() {
			window.$store.dispatch('Login/aiLogout')
			.then(() => {
				this.$router.push('/ai');
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/App.vue